document.addEventListener("click", function (e) {
    if (!e.target || !(e.target instanceof Element)) return;
    // allow our own quick-add buttons or DY slider buttons
    var btn = e.target.closest("[data-add-to-cart-id], .dy-recommendation-item__add-to-cart");
    if (!btn || !(btn instanceof HTMLButtonElement)) return;

    // Rebuy widgets own their add-to-cart lifecycle. Do not hijack their buttons,
    // otherwise Rebuy's before/add callbacks can be bypassed.
    if (btn.closest(".rebuy-widget, [data-rebuy-id], [data-rebuy-widget-id]")) return;
  
    e.preventDefault();
  
    /** @type {HTMLButtonElement} */
    var button = btn;

    // variant id may come from custom attribute or DY slider attribute
    var variantId = button.getAttribute("data-add-to-cart-id") || button.getAttribute("data-variant-id");
    if (!variantId) return;

  button.disabled = true;
  button.textContent = "Hinzufügen...";

  var bmsmEnabled = button.getAttribute("data-bmsm-enabled") === "true";
  var properties = null;

  if (bmsmEnabled) {
    var groupId = button.getAttribute("data-bmsm-group-id") || "";

    if (!groupId) {
      var productId = button.getAttribute("data-product-id") || "";
      groupId = productId ? "bmsm-" + productId : "bmsm-" + String(Date.now());
    }

    properties = {
      _bmsm_group_id: groupId,
      _bmsm_group_name: "Buy More Save More",
      _bmsm_buy2: button.getAttribute("data-bmsm-buy2-discount") || "",
      _bmsm_buy3: button.getAttribute("data-bmsm-buy3-discount") || "",
      _bmsm_buy4: button.getAttribute("data-bmsm-buy4-discount") || "",
      _bmsm_buy5: button.getAttribute("data-bmsm-buy5-discount") || ""
    };
  }

  fetch("/cart/add.js", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      id: variantId,
      quantity: 1,
      ...(properties ? { properties: properties } : {})
    })
  })
  .then(function(res){ return res.json(); })
  .then(function(data){

    button.textContent = "Hinzugefügt ✓";

    // 🔔 Notify theme cart changed
    document.dispatchEvent(new CustomEvent("cart:refresh"));
    document.dispatchEvent(new CustomEvent("cart:updated"));

    // 🔄 Reload cart data and open drawer
    fetch("/cart.json")
      .then(function(res){ return res.json(); })
      .then(function(cart){

        // Dispatch update event - don't include sections since they're not available
        document.dispatchEvent(new CustomEvent("cart:update", {
          detail: { source: "add-to-cart", cart: cart, data: { sections: null } }
        }));

        // 🛒 Open mini cart automatically AFTER cart is updated
        var cartDrawer = document.querySelector("cart-drawer-component");
        if (cartDrawer && cartDrawer instanceof HTMLElement) {
          /** @type {HTMLElement & {open?: function(): void}} */
          var drawer = cartDrawer;
          if (drawer.open) {
            drawer.open();

            document.dispatchEvent(new CustomEvent("cart-drawer:open"));
          }
        }
      });

    setTimeout(function(){
      button.disabled = false;
      button.textContent = "In den Warenkorb";
    }, 2000);

  })
  .catch(function(){
    button.textContent = "Error";
    button.disabled = false;
  });
});


// ---------------------------------------------------------------------------
// helper used elsewhere in theme to keep mini cart in sync
// (uses same section‑fetching principle as quantity change)
// ---------------------------------------------------------------------------

/**
 * Fetch the cart drawer + icon sections and replace their HTML.
 * Dispatches a cart:update event so other listeners (bv-mini-cart etc.)
 * can react the same way they do when quantity changes.
 */
function refreshMiniCart() {
  // Use /cart.json instead of sections endpoint since sections seem unavailable
  fetch("/cart.json")
    .then(function (res) { return res.json(); })
    .then(function (cart) {
      
      // Dispatch event so listeners can react - pass null sections to avoid errors
      document.dispatchEvent(new CustomEvent("cart:update", {
        detail: { source: "refresh-on-open", cart: cart, data: { sections: null } }
      }));
    })
    .catch(function (err) {
      console.error("Mini cart refresh failed:", err);
    });
}

// expose helper globally so other modules (cart-drawer.js) can invoke directly
window.refreshMiniCart = refreshMiniCart;

// refresh whenever the drawer is opened by any mechanism
// note: this may fire prior to the built‑in open call, but that is harmless
// since refreshMiniCart will rewrite the contents before display

document.addEventListener("cart-drawer:open", refreshMiniCart);
